import { Injectable } from '@angular/core';
import { HttpPostModel } from '@rift/models/restapi/HttpPost.Model';
import { ResultModel } from '@rift/models/restapi/Result.Model';
import { RiftBaseService } from '@rift/service/base/RiftBase.Service';
import { RestApiOutboundService } from '@rift/service/restapi/v1/RestApi.Outbound.Service';
import { ObservableTracker } from '@shared/generic/ObservableLoading';
import { ProcessMonitorServiceProcess } from '@shared/service/processmonitor/ProcessMonitor.Service.Process';
import { isNullOrUndefined } from '@shared/utility/General.Utility';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable()
export class HttpPostService extends RiftBaseService {

    private _getHttpPostLoadingTracker = new ObservableTracker<HttpPostModel>();
    private _httpPostCache: HttpPostModel;

    private _updateHttpPostLoadingTracker = new ObservableTracker<ResultModel>();

    public constructor(
        private readonly _restApiOutboundService: RestApiOutboundService) {
        super();
    }

    public clearCache(): void {
        this.clearObservableTrackers();
        this._httpPostCache = null;
    }
    public getHttpPost(process?: ProcessMonitorServiceProcess): Observable<HttpPostModel> {
        if (isNullOrUndefined(this._httpPostCache)) {
            return this._getHttpPostLoadingTracker
                .getLoading()
                .observable(this._restApiOutboundService.getHttpPost(process).pipe(
                    map(result => {
                        this._httpPostCache = result;
                        return this._httpPostCache;
                    })
                ));
        } else {
            return of(this._httpPostCache);
        }
    }

    public setCache(httpPostCache: HttpPostModel): Observable<boolean> {
        this._httpPostCache = httpPostCache;
        return of(true);
    }
    public updateHttpPost(httpPost: HttpPostModel, process?: ProcessMonitorServiceProcess): Observable<ResultModel> {
        return this._updateHttpPostLoadingTracker
            .getLoading(httpPost)
            .observable(this._restApiOutboundService.updateHttpPost(httpPost, process).pipe(tap(() => this._httpPostCache = null)));
    }
}
